module.exports = __webpack_public_path__ + "img/garbage_access.57a08e04.png";